import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MailTemplate } from './mailtemplate';
import { environment } from '../../../environments/environment';

let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');
@Injectable({
  providedIn: 'root'
})

export class MailTemplateService {
  constructor(private httpClient: HttpClient) { }
  baseUrl: string = environment.serviceUrl;
  //httpclient get method
  Get(): Observable<MailTemplate[]> {
    return this.httpClient.get<MailTemplate[]>(this.baseUrl + 'api/MailTemplateApi/');
  };

  //httpclient method to get the mail template info for the given id/name
  Getbyinfo(_mailtemModel: MailTemplate): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/MailTemplateApi/GetById', _mailtemModel, { headers: header, observe: 'response' });
  }

  //httpclient post method
  Post(_mailtemModel: MailTemplate): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/MailTemplateApi/add', _mailtemModel,
      { headers: header, observe: 'response' });
  }

  //httpclient put method
  Put(_mailtemModel: MailTemplate): Observable<any> {
    return this.httpClient.put<any>(this.baseUrl + 'api/MailTemplateApi/Update', _mailtemModel,
      { headers: header, observe: 'response' });
  }
  //httpclient delete method
  Delete(_mailtemModel: MailTemplate): Observable<any> {
    return this.httpClient.put<any>(this.baseUrl + 'api/MailTemplateApi/activeordeactive', _mailtemModel, { headers: header, observe: 'response' })
  }
}
